import { GtfsFollowFields } from "./useGtfsFollow";

interface GtfsFollowNoticeProps {
  nameEdited: boolean;
  locationEdited: boolean;
  canFollow: boolean;
  resetting: boolean;
  onFollow: (fields: GtfsFollowFields) => void;
}

// One small line at the bottom of the station page when the GTFS feed uses its own name or
// location for this station instead of following it. The save-time confirm is the real warning;
// this only tells why and offers the way back.
const GtfsFollowNotice: React.FC<GtfsFollowNoticeProps> = ({
  nameEdited,
  locationEdited,
  canFollow,
  resetting,
  onFollow
}) => {
  if (!nameEdited && !locationEdited) return null;

  const fields = [nameEdited && "emrin", locationEdited && "vendndodhjen"].filter(Boolean).join(" dhe ");
  const fieldsOf = [nameEdited && "emrit", locationEdited && "vendndodhjes"].filter(Boolean).join(" dhe ");
  const linkClass = "text-primary underline underline-offset-2 disabled:opacity-60";

  return (
    <p className="mx-5 mt-6 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-gray-500">
      <span>
        GTFS nuk e ndjek këtë stacion për {fields}: ndryshimet e {fieldsOf} këtu nuk shkojnë te Google.
      </span>
      {canFollow && nameEdited && (
        <button
          type="button"
          className={linkClass}
          disabled={resetting}
          onClick={() => onFollow({ name: true })}
        >
          Bëje GTFS të ndjekë emrin
        </button>
      )}
      {canFollow && locationEdited && (
        <button
          type="button"
          className={linkClass}
          disabled={resetting}
          onClick={() => onFollow({ location: true })}
        >
          Bëje GTFS të ndjekë vendndodhjen
        </button>
      )}
    </p>
  );
};

export default GtfsFollowNotice;
